import React, { FormEvent } from 'react'

import { receivingContext, ReceivingFlowController } from '../flow'
import { ActionButton, RfShell } from '../components/RfShell'
import { RfScanField } from '../components/RfScanField'
import { RfStatusBanner } from '../components/RfStatusBanner'
import { ScanForm, TaskHeader } from '../styles'

interface LineProductScanScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}

export const LineProductScanScreen = ({ controller, embedded = false, onExit }: LineProductScanScreenProps) => {
  const { state, dispatch } = controller

  const submitBarcode = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    dispatch({ type: 'submit-line-product-barcode' })
  }

  return (
    <RfShell
      title="Receiving"
      phase="Select variant"
      embedded={embedded}
      contextSummary={receivingContext(state)}
      contextDetails={null}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
      actions={
        <ActionButton type="submit" form="line-product-form">
          Continue
        </ActionButton>
      }
    >
      {state.status && state.status.tone !== 'success' ? (
        <RfStatusBanner tone={state.status.tone}>{state.status.message}</RfStatusBanner>
      ) : null}
      <TaskHeader>
        <h1>Scan product</h1>
      </TaskHeader>
      <ScanForm id="line-product-form" aria-label="Scan product barcode" onSubmit={submitBarcode}>
        <RfScanField
          label="Product barcode"
          value={state.lineProductBarcode}
          placeholder="Scan product barcode"
          hint="No barcode? Leave blank to enter the SKU."
          onChange={(barcode) => dispatch({ type: 'set-line-product-barcode', barcode })}
        />
      </ScanForm>
    </RfShell>
  )
}
